module.exports = {
  // Can't have forward slash!
  siteUrl: 'https://www.advictorem.agency',
  domainRegex: /http[s]*:\/\/[www.]*advictorem\.\w+[/]?/,
  blogPathname: 'blog',
  siteName: 'Ad Victorem',
  shortSiteName: 'Ad Victorem',
  startUrl: '/',
  defaultLang: 'en',
  defaultTitle:
    'Ad Victorem - For Those Who Dare To Win | Brand Strategy + Design',
  defaultDescription:
    'We are a competitive branding and marketing agency that combines award-winning creativity and business strategy for those who dare to win.',
  defaultKeywords: [
    'branding',
    'creative',
    'marketing',
    'design',
    'strategy',
    'naming',
    'identity',
    'branding',
    'logo',
    'website design',
    'video',
    'campaigns',
    'digital',
    'UX',
    'web development',
    'Los Angeles',
    'Hollywood',
    'California',
    'North America',
    'consultancies',
    'global',
    'agency',
  ],
  twitterCreator: '@Ad_Victorem',
  twitterSite: '@Ad_Victorem',
  gaTrackingId: 'UA-110990504-1',
  // fbAppId: '__TODO__________________________________',
}
